<template>
  <div class="grid">
    <div class="col-12">
      <div class="card">

        <Toast />
        <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-2">


            </div>
          </template>


          <template v-slot:end>
            <!-- <FileUpload
              mode="basic"
              accept="image/*"
              :maxFileSize="1000000"
              label="Import"
              chooseLabel="Import"
              class="mr-2 inline-block"
            />-->
            <Button label="Importar CSV" icon="pi pi-upload" class="p-button-success" @click="importarCsv()" />
          </template>
        </Toolbar>

        <div style="width: 100%; overflow: auto;">
          <h3>Padrão das colunas (Antes de Importar remover cabeçalho)</h3>
          <table class="tabela">
            <thead>
              <tr>
                <th title="Field #1">Número do Cliente</th>
                <th title="Field #2">Número da Instalação</th>
                <th title="Field #3">Mês Competência</th>
                <th title="Field #4">Medidor</th>
                <th title="Field #5">Data Leitura Anterior</th>
                <th title="Field #6">Data Leitura Atual</th>
                <th title="Field #7">Próxima Leitura</th>
                <th title="Field #8">Data de Emissão</th>
                <th title="Field #9">Data de Vencimento</th>
                <th title="Field #10">Custo de Disponibilidade kWh</th>
                <th title="Field #11">Custo de Disponibilidade (R$)</th>
                <th title="Field #12">Leitura Anterior</th>
                <th title="Field #13">Leitura Atual</th>
                <th title="Field #14">Constante</th>
                <th title="Field #15">Consumo Registrado kWh</th>
                <th title="Field #16">Consumo Faturado kWh</th>
               
                <th title="Field #16">Tarifa TUSD Consumo c/ imposto R$</th>
                <th title="Field #16"> Tarifa TE c/ Consumo imposto R$</th>              
                <th title="Field #17">Tarifa Cheia Consumo c/ impostos (R$)</th>
               
                <th title="Field #18">Valor Consumo kWh (R$)</th>
                <th title="Field #19">Energia Compensada kWh</th>

                <th title="Field #19">Tarifa TUSD Energia Compensada c/ impostos R$</th>
                <th title="Field #19">Tarifa TE Energia Compensada c/ impostos R$</th>
                <th title="Field #20">Tarifa Cheia Energia Compensada c/ impostos (R$)</th>
                <th title="Field #21">Valor Energia Compensada (R$)</th>
                <th title="Field #22">Energia injetada kWh</th>
                
                <th title="Field #23">Tarifa TUSD Energia Injetada c/ impostos R$</th>
                <th title="Field #23">Tarifa TE Energia Injetada c/ impostos R$</th>
                <th title="Field #23">Tarifa Cheia Energia Injetada c/ impostos (R$)</th>
                
                <th title="Field #24">Valor Energia Injetada (R$)</th>
                <th title="Field #47">Saldo utilizado no mês</th>
                <th title="Field #25">Saldo Atual Geração Ponta</th>
                <th title="Field #26">Saldo Atual Geração F. Ponta</th>
                <th title="Field #27">Saldo Atual Geração Total</th>
                <th title="Field #28">UFER kVARh</th>
                <th title="Field #29">Tarifa UFER com impostos (R$)</th>
                <th title="Field #30">UFER Valor (R$)</th>
                <th title="Field #31">llum.Pub.Municipal (R$)</th>
                <th title="Field #32">Devoluções (R$)</th>
                <th title="Field #33">Outras Despesas (R$)</th>
                <th title="Field #34">Base de Cálculo ICMS (R$)</th>
                <th title="Field #35">Alíquota ICMS %</th>
                <th title="Field #36">Valor ICMS R$</th>
                <th title="Field #37">Base de Cálculo PIS/PASEP R$</th>
                <th title="Field #38">Alíquota PIS/PASEP %</th>
                <th title="Field #39">Valor PIS/PASEP R$</th>
                <th title="Field #40">Base de Cálculo COFINS R$</th>
                <th title="Field #41">Alíquota COFINS %</th>
                <th title="Field #42">Valor COFINS R$</th>
                <th title="Field #43">Total da Fatura</th>
                
                
                <th title="Field #44">Tarifa TUSD Consumo s/ imposto R$</th>
                <th title="Field #44">Tarifa TE s/ Consumo imposto R$</th>
                <th title="Field #44">Tarifa Cheia Consumo s/ impostos (R$)</th>
                
                
                <th title="Field #45">Tarifa TUSD Energia Compensada s/ imposto R$</th>
                <th title="Field #45">Tarifa TE c/ Energia Compensada s/ imposto R$</th>
                <th title="Field #45">Tarifa Cheia Energia Compensada s/ impostos (R$)</th>
                
                
                <th title="Field #46">Tarifa UFER (sem imposto)</th>
                <th title="Field #47">url</th>

                
                <th title="Field #47">Energia_Compensada_2_kWh</th>
                <th title="Field #47">Tarifa_TUSD_Energia_Compensada_2</th>
                <th title="Field #47">Tarifa_TE_Energia_Compensada_2</th>
                <th title="Field #47">Tarifa_Cheia_Energia_Compensada_2_com_impostos_R</th>
                <th title="Field #47">Valor_Energia_Compensada_2_R</th>
                <th title="Field #47">Energia_Compensada_3_kWh</th>
                <th title="Field #47">Tarifa_TUSD_Energia_Compensada_3</th>
                <th title="Field #47">Tarifa_TE_Energia_Compensada_3</th>
                <th title="Field #47">Tarifa_Cheia_Energia_Compensada_3_com_impostos_R</th>
                <th title="Field #47">Valor_Energia_Compensada_3_R</th>
                <th title="Field #47">Adicional_Bandeira_R</th>

                <th title="Field #47">Tarifa_TUSD_Energia_Compensada_2_s_imposto</th>
                <th title="Field #47">Tarifa_TE_Energia_Compensada_2_s_imposto</th>
                <th title="Field #47">Tarifa_Cheia_Energia_Compensada_2_s_imposto</th>
                <th title="Field #47">Tarifa_TUSD_Energia_Compensada_3_s_imposto</th>
                <th title="Field #47">Tarifa_TE_Energia_Compensada_3_s_imposto</th>
                <th title="Field #47">Tarifa_Cheia_Energia_Compensada_3_s_imposto</th>

               
                
              </tr>
            </thead>
            <tbody></tbody>
          </table>


        </div>


        <Dialog v-model:visible="modalcsv" :style="{ width: '450px' }" :modal="true" header="Importar CSV - Separdo por ;">
          <div class="flex align-items-center justify-content-center">
            <div class="field">

              <FileUpload chooseLabel="Selecionar arquivo csv" ref="arquivo" mode="basic" name="arquivo"
                v-on:change="onChangeFileUpload()" />
            </div>
          </div>
          <template #footer>
            <Button label="Não" icon="pi pi-times" class="p-button-secondary p-button-sm" @click="modalcsv = false" />
            <Button label="Importar" icon="pi pi-check" class="p-button-success p-button-sm" @click="enviarCsv()" />
          </template>
        </Dialog>


      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalcsv: false,
      usinas: [],
      id_usina: "",
      ano: "",
      mes: "",
      anos: [
        { label: "", value: "" },
        { label: "2022", value: "2022" },
        { label: "2023", value: "2023" },{ label: "2024", value: "2024" },{ label: "2025", value: "2025" }],
      meses: [
        { label: "", value: "" },
        { label: "Janeiro", value: "01" },
        { label: "Fevereiro", value: "02" },
        { label: "Março", value: "03" },
        { label: "Abril", value: "04" },
        { label: "Maio", value: "05" },
        { label: "Junho", value: "06" },
        { label: "Julho", value: "07" },
        { label: "Agosto", value: "08" },
        { label: "Setembro", value: "09" },
        { label: "Outubro", value: "10" },
        { label: "Novembro", value: "11" },
        { label: "Dezembro", value: "12" },
      ],
      columns: null,
      energia: [],
      prioridades: [
        { label: "0", value: "0" },
        { label: "1", value: "1" },
        { label: "2", value: "2" },
      ],
      arquivo: "",
      mostrar_download: false,
      prioridade: "",
      unidades: [],
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      unidade: {},
      selectedProducts: null,
      filters: {},
      submitted: false,
      status: 0,
      empresas: [],
      areas: [],
      regionais: [],
      tipos: [],
      estados: [],
      cidades: [],
      id_estado: "",
      id_cidade: "",
      statuses: [
        { label: "Inativo", value: "0" },
        { label: "Ativo", value: "1" },
      ],
    };
  },
  productService: null,

  mounted() {

  },
  methods: {
    enviarCsv() {
      let formData = new FormData();
      formData.append("arquivo", this.arquivo);

      this.axios
        .post("/eum/upload", formData)
        .then(() => {

          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Planilha Importada com sucesso",
            life: 3000,
          });
          this.modalcsv = false;
        })
        .catch(() => {

          this.$toast.add({
            severity: "error",
            summary: "Ops!",
            detail: "Chamar o T.I.",
            life: 3000,
          });
        });
    },

    onChangeFileUpload() {
      this.arquivo = this.$refs.arquivo.files[0];
    },

    importarCsv() {
      this.modalcsv = true;
    },


  },
};
</script>

<style scoped>
.tabela {
  margin: 20px 0;
}
.tabela th{
 white-space: nowrap;
 background: #EEE;
 padding: 5px;
}
</style>
